
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const BusinessInfoContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Angaben gemäß § 5 TMG</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 text-joerg-600">
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Kontaktdaten</h4>
          <div className="space-y-1">
            <p>Jörg Hörmann Coaching & Consulting</p>
            <p>Grimmstr. 15</p>
            <p>91154 Roth</p>
            <p className="mt-3">Einzelunternehmen</p>
          </div>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Vertreten durch</h4>
          <p>Jörg Hörmann</p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Kontakt</h4>
          <div className="space-y-1">
            <p>Telefon: 09171-9892118</p>
            <p>E-Mail: <a href="mailto:info@joerg-hoermann.de" className="text-primary hover:underline">info@joerg-hoermann.de</a></p>
            <p>Internet: <a href="https://www.joerg-hoermann.de" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">www.joerg-hoermann.de</a></p>
          </div>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Umsatzsteuer-ID</h4>
          <p>Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE346500257</p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Streitschlichtung</h4>
          <p className="text-sm leading-relaxed">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://ec.europa.eu/consumers/odr/</a>.<br />Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
          <p className="text-sm mt-2 leading-relaxed">
            Wir legen großen Wert auf Kundenzufriedenheit und bemühen uns, etwaige Meinungsverschiedenheiten direkt und einvernehmlich zu lösen. Bei Fragen oder Anliegen kontaktieren Sie uns bitte unter den oben angegebenen Kontaktdaten, bevor Sie ein formelles Streitbeilegungsverfahren in Betracht ziehen.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default BusinessInfoContent;
